// Components MUI
import Typography from '@mui/material/Typography';
import { Tooltip } from '@mui/material';

// Datepicker
import 'dayjs/locale/es';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";

import { useTranslation } from "react-i18next";

// Components
import { FormButton } from '../../../../pages/styles';
import {
    Container,
    Header,
    Body,
    Footer,
    BoxContainer,
    SectionRight,
    ContainerDates,
    ContainerGroup,
    ContainerInputsDate,
    CleanIcon,
} from './style';
import { ClearIconButton } from '../FiltersWorkflowModalCard/style';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/de';
import moment from "moment";

export const RevalidationsExcelDownload = ({datesDownloadValid, setOpendownloadValidations, handleChangeDateDownload, handleDownloadExcel, errorsDate, handleClearDates }) => {

  const { t } = useTranslation();
  dayjs.locale('es');



    return (
        <Container>
            <Header>Descargar revalidaciones</Header>
            <Body>
                <BoxContainer>
                    <ContainerDates>
                        <Typography variant="caption" sx={{ marginBottom: '20px' }}>
                            {t('common.downloadExcel')}
                        </Typography>
                        <ContainerGroup>
                            {/* Input desde */}
                            <ContainerInputsDate errorstart={errorsDate.startDate}>
                                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            label={t("common.initDate")}
                                            value={datesDownloadValid?.startDate ? moment(datesDownloadValid?.startDate) : null}
                                            minDate={moment('2020-03-20')}
                                            maxDate={moment()}
                                            onChange={e => handleChangeDateDownload(e || "", "startDate")}
                                            slotProps={{ textField: { size: 'small', error: errorsDate.startDate, required: errorsDate.startDate } }}
                                            format="DD/MM/YYYY"
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </ContainerInputsDate>
                            {/* Input hasta */}
                            <ContainerInputsDate errorend={errorsDate.endDate}>
                                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            label={t("common.lastDate")}
                                            value={datesDownloadValid?.endDate ? moment(datesDownloadValid?.endDate) : null}
                                            minDate={moment(datesDownloadValid?.startDate)}
                                            maxDate={moment()}
                                            onChange={(e) => handleChangeDateDownload(e || "", "endDate")}
                                            slotProps={{ textField: { size: 'small', error: errorsDate.endDate, required: errorsDate.endDate } }}
                                            format="DD/MM/YYYY"
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </ContainerInputsDate>

                            <Tooltip>
                                <ClearIconButton
                                    size="small"
                                    aria-label="plot"
                                    onClick={handleClearDates}
                                >
                                    <CleanIcon/>
                                </ClearIconButton>

                            </Tooltip>
                        </ContainerGroup>
                    </ContainerDates>
                </BoxContainer>
            </Body>
            <Footer>
                <SectionRight>
                    <FormButton onClick={() => setOpendownloadValidations(false)} type='close' variant="outlined">{t('common.cancel')}</FormButton>
                    <FormButton onClick={handleDownloadExcel}>{t('common.download')}</FormButton>
                </SectionRight>
            </Footer>
        </Container>
    )
}
